import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-store-results',
  templateUrl: './store-results.component.html',
  styleUrls: ['./store-results.component.scss']
})
export class StoreResultsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
